import React, { FC } from 'react'

import { Alert } from '@app/types/alert'
import { AppIcon } from '@app/components/AppIcon'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'

import theme from '../../../../../../../theme'
import AppAlertBase from '../../../../../../../components/AppAlertBase'
import AlertEventTime from '../../../../../../../components/AlertEventTime'

interface SidebarInactiveAlertProps {
	readonly alert: Alert
}

const SidebarInactiveAlert: FC<SidebarInactiveAlertProps> = ({
	alert,
}: SidebarInactiveAlertProps) => {
	const {
		formatters: { tdf3 },
	} = useTimeController()
	const eventTime = tdf3(alert.op?.addedTimestamp)

	return (
		<>
			<AppAlertBase
				iconSlot={
					<AppIcon type={'inactiveSmile'} width={38} height={38} />
				}
				iconBoxSx={{
					bgcolor: theme.palette.secondary.light,
					height: 'auto',
				}}
				title={'Inactive'}
				subTitle={alert.data?.alert_description || ''}
			/>

			<AlertEventTime eventTime={eventTime} />
		</>
	)
}

export default SidebarInactiveAlert
